<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import appConfig from "@/app.config";
    
    export default {
        page: {
            title: "Agencies",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: "Agencies",
                items: [
                {
                    text: "Agencies",
                    active: true,
                },                   
                ],

                agencies: [],
                agency_status: {
                    id: "",
                    status: "",
                },
                listing_length: 10,
                keyword: '',
                status: '',
                from: null,
                to: null,
                total: null,
                pagination: {},
                token: "",
                errors: {},
                activate: false,
                deactivate: false,

                active_page_url: null,
            };
        },
        mounted() {
            this.clearLocalStorage();

        },

        created() {
            this.fetchAgencies();
        },

        methods: {
            clearLocalStorage() {
                localStorage.removeItem("consultation_filters");
                localStorage.removeItem("cancel_consultation_filters");
                localStorage.removeItem("patient_filters");
                localStorage.removeItem("doctor_filters");
            },

            fetchAgencies(page_url = null) 
            {
                this.getToken();
                let url = "api/admin/viewAgency?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

                page_url = page_url || url;

                if(localStorage.back_url) {
                    page_url = localStorage.back_url;  
                    localStorage.removeItem('back_url');
                }    

                this.active_page_url = page_url;
                this.loading = true;
                
                this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.agencies = responseData.agencies.data;
                    
                    this.pagination = responseData.agencies.links;
                    this.from = responseData.agencies.from;
                    this.to = responseData.agencies.to;
                    this.total = responseData.agencies.total;
                
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                            console.log(error.response.status);
                            } else {
                            this.$swal("", error.response.data.message, "error");
                            }                        
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }, 

            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

            activateAgency(agency) {
                this.activate = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to activate this agency?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.activate = value
                    if(this.activate){
                    this.agency_status.id = agency.id;
                    this.agency_status.status = 1;
                    this.updateAgencyStatus();
                }
                })
                .catch(err => {
                    console.log(err);
                })
            },

            deactivateAgency(agency) {
                this.deactivate = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to block this agency?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.deactivate = value
                    if(this.deactivate){
                    this.agency_status.id = agency.id;
                    this.agency_status.status = 2;
                    this.updateAgencyStatus();
                }
                })
                .catch(err => {
                    console.log(err);
                })
            },

            updateAgencyStatus() {
                
                this.getToken();
                const config = {
                headers: {
                    "Content-type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

        
                let url = "api/admin/updateAgencyStatus?agency_id=" + this.agency_status.id + "&status=" + this.agency_status.status;
                this.$axios
                .get(url, config)
                .then((response) => {                  
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchAgencies(this.active_page_url);
                })
                .catch((error) => {                
                    if (error.response) {
                        if (error.response.data.message) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                });
            },

            deleteAgency(agency_id) 
            {
                this.delete = false;
                this.$bvModal.msgBoxConfirm('Are you sure you want to delete this agency?', {
                    title: 'Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                this.delete = value
                if(this.delete){
                    this.getToken();           
                
                    const config = {
                        headers: {
                            "Content-type": "application/json",
                            "Accept": "application/json",
                            "Authorization": "Bearer " + this.token,
                        },
                    };
                    console.log(this.token);
                    let formData = new FormData();
                    formData.append("agency_id", agency_id); 

                    let url = "api/admin/deleteAgency";
                    this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                            if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                            } else {
                            this.$swal("", response.data.message, "error");
                            }
                            this.fetchAgencies(this.active_page_url);
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                            } else {
                            this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
                    .finally(() => (this.loading = false));
                }
                })
                .catch(err => {
                console.log(err);
                })
            },
            
        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                <div class="card-body">
                    <!-- <h4 class="card-title"></h4>
                    <p class="card-title-desc"></p> -->

                    <!----- top button area starts---->
                    <div class="row mb-3">
                        <div class="col-12">                        
                            <router-link :to="{ name: 'agencies.add' }" class="btn btn-primary float-end">Add Agency</router-link>
                        </div>
                    </div>
                    <!----- top button area ends---->

                    <!----- Listing length and search starts ----->
                    <div class="row mb-3">
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-length" >
                            <label
                                >Show
                                <select class="form-control" v-model="listing_length" @change="fetchAgencies()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                </select>
                                entries
                            </label>
                            </div>                        
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-filter">
                            <label>
                                <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchAgencies()"/>
                            </label>
                            </div>                     
                            <div class="listing-filter me-2">
                            <label>
                                <select class="form-control" v-model="status" @change="fetchAgencies()">
                                    <option value="">All</option>
                                    <option value="1">Active</option>
                                    <option value="2">Blocked</option>
                                </select>
                            </label>
                            </div>   
                        </div>
                    </div>
                    <!----- Listing length and search ends ----->

                    <!---- listing table starts -------->
                    <div class="table-responsive">
                        <table class="table table-bordered mb-0">

                            <thead class="table-light">
                            <tr>
                                    <th>Sl No</th>  
                                    <th>Name</th>  
                                    <th>Contact</th> 
                                    <th>Commission</th>
                                    <th>Status</th> 
                                    <th>Created on</th>
                                    <th>Options</th>
                            </tr>
                            </thead>

                            <tbody v-if="Boolean(agencies.length)">
                            <tr v-for="(agency, index) in agencies" :key="agency.id">
                                <td>{{from + index}}</td>
                                <td>{{agency.name}}</td>
                                <td>{{agency.country_code}} {{agency.mobile}}<br>
                                    {{agency.email}}
                                </td>
                                <td>TV Show: {{agency.tv_commission}}<br>
                                    Image: {{agency.image_commission}}
                                </td>
                                <td>
                                    <span v-if="agency.status == 1" class="badge rounded-pill bg-success">Active</span>
                                    <span v-if="agency.status == 2" class="badge rounded-pill bg-danger">Blocked</span>
                                </td>
                                <td>{{agency.converted_created_at | formatDateTime }}</td>
                                <td>
                                    
                                    <!-- <router-link :to="{ name: 'agencies.details', params: {id: clinic.id} }" class="btn btn-primary btn-sm me-2 mb-2">Profile</router-link> -->
                                    <router-link :to="{ name: 'agencies.edit', params: {id: agency.id} }" class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link>
                                    <b-button v-if="agency.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateAgency(agency)">Block</b-button>

                                    <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateAgency(agency)">Activate</b-button>

                                    <button class="btn btn-danger btn-sm mb-2" type="button" @click="deleteAgency(agency.id)">Delete</button>
                                </td>
                            </tr>
                            </tbody>

                            <tbody v-else>
                            <tr>
                                <td colspan="6" class="text-center">No agencies found</td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <!---- listing table ends -------->

                    <!----pagination starts ---> 
                    <caption v-if="Boolean(agencies.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                    <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                        <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                            <a href="#" class="page-link" @click.prevent="fetchAgencies(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                            <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                            <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                            <span v-else>{{page.label}}</span>                          
                            </a>
                        </li>
                    </ul>
                    <!----pagination ends --->              

                </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
